import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import ProductProp, { PACK_TYPE } from '../../../propTypes/productProp';

function AddEditSection({
  t,
  isEditable,
  openModal,
  pack,
  isJourney,
  product,
}) {
  const { amountVariationsPerAdvancedPack } = pack || {};

  const emptyAvailable =
    isJourney &&
    ((product?.packType === PACK_TYPE.ADVANCED_PACK &&
      product?.packVariationsAvailable?.length === 0) ||
      (product?.packType === PACK_TYPE.HYBRID_PACK &&
        product?.multiPackVariationsAvailable?.length === 0));
  return (
    <div
      className="edit-advancedPack-section"
      style={{
        justifyContent: isEditable ? 'flex-end' : 'flex-start',
      }}
    >
      {emptyAvailable ? (
        <button
          className="editBtn"
          type="button"
          onClick={event => {
            event.preventDefault(); // Prevents the <a> navigation
            event.stopPropagation();
            openModal('add');
          }}
        >
          <span className="info">{t('shop.hybrid_pack.products')}</span>
        </button>
      ) : (
        <>
          {!isEditable && (
            <button
              className="addBtn"
              type="button"
              onClick={event => {
                event.preventDefault(); // Prevents the <a> navigation
                event.stopPropagation();
                openModal('add');
              }}
            >
              <div className="plus">
                <i className="fa fa-plus" />
              </div>
              <span className="info">
                {t(
                  'advancedPack.amountOfProducts',
                  amountVariationsPerAdvancedPack,
                )}
              </span>
            </button>
          )}
          {isEditable && (
            <button
              className="editBtn"
              type="button"
              onClick={event => {
                event.preventDefault(); // Prevents the <a> navigation
                event.stopPropagation();
                openModal('edit');
              }}
            >
              <div className="edit">
                <i className="fa fa-pen" />
              </div>
              <span className="info">{t('advancedPack.edit')}</span>
            </button>
          )}
        </>
      )}
    </div>
  );
}

AddEditSection.propTypes = {
  t: PropTypes.func.isRequired,
  pack: PropTypes.shape({
    amountVariationsPerAdvancedPack: PropTypes.number.isRequired,
  }).isRequired,
  isEditable: PropTypes.bool,
  isJourney: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductProp.propType),
};

AddEditSection.defaultProps = {
  isEditable: false,
  isJourney: false,
  product: {
    packVariationsAvailable: [],
  },
};

export default translate(AddEditSection);
